import React from 'react';
import { Heart, User, Bone, AlertCircle, Baby, BrainCircuit, Activity, Pill } from 'lucide-react';

const MedicalRequirements = () => {
  const medicalConditions = [
    { icon: Heart, label: 'Heart Issues', delay: 0 },
    { icon: User, label: 'Pregnancy', delay: 0.15 },
    { icon: Bone, label: 'Back or Neck Pain', delay: 0.3 },
    { icon: AlertCircle, label: 'high or low bp', delay: 0.45 },
    { icon: Baby, label: 'Recent Surgery', delay: 0.6 },
    { icon: BrainCircuit, label: 'Neurological Issues', delay: 0.75 },
    { icon: Activity, label: 'Joint Problems', delay: 0.9 },
    { icon: Pill, label: 'On Medication', delay: 1.05 }
  ];
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Centered Header */}
        <div className="text-center mb-4">
          <h2 className="text-4xl md:text-5xl font-black mb-2" style={{ color: '#00A8E1', fontFamily: 'Inter, sans-serif' }}>
            MEDICAL REQUIREMENTS
          </h2>
          <p className="text-base md:text-base text-gray-600 font-light" style={{ fontFamily: 'Inter, sans-serif', fontSize: 'clamp(14px, 2.5vw, 16px)' }}>
            Jumpers with Following Medical Conditions Are Not Allowed to Jump
          </p>
        </div>

        {/* Horizontal Scrolling Icons Line */}
        <div className="overflow-hidden mb-4">
          <div className="animate-slide-horizontal-fast flex space-x-4 py-4">
            {/* Triple icons for truly seamless loop */}
            {[...medicalConditions, ...medicalConditions, ...medicalConditions].map((condition, index) => {
              const IconComponent = condition.icon;
              return (
                <div
                  key={index}
                  className="flex-shrink-0 flex flex-col items-center text-center space-y-2"
                >
                  {/* Icon Circle */}
                  <div className="w-28 h-28 rounded-full bg-yellow-400 flex items-center justify-center shadow-lg">
                    <IconComponent className="text-black" size={48} strokeWidth={2.5} />
                  </div>
                  
                  {/* Label */}
                  <p className="text-gray-900 text-sm whitespace-nowrap font-light">
                    {condition.label}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-2xl mx-auto">
          {/* Have Doubt Text */}
          <div className="text-center mb-3">
            <p className="text-sm text-gray-600">
              Have Doubt?
            </p>
          </div>

          {/* CTA Button - Centered */}
          <div className="text-center">
            <button
              className="inline-flex items-center space-x-2 bg-yellow-400 hover:bg-yellow-300 text-black px-12 py-4 rounded-full font-black text-xl transition-all transform hover:scale-105 shadow-lg shadow-yellow-400/50"
             
            >
              <span>Contact Our Expert</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MedicalRequirements;